export default "__VITE_ASSET__DeYnE0jW__"